import { RootAction, Page } from "../types";
import { User } from "../session/types";
import { Patient } from "../patient/types";

export interface State {
  data: {
    token: string;
    user: User | null;
    patientList: Page<Patient>;
    searchString: string;
    selectedPatient: Patient | null;
    showInactive: boolean;
    locations: string[];
    selectedLocation: string;
  };
  loading: boolean;
  passsiveLoading: boolean;
}

const blankState = () => ({
  data: {
    token: "",
    user: null,
    patientList: { count: 1, next: "", previous: "", results: [] },
    searchString: "",
    selectedPatient: null,
    showInactive: false,
    locations: [],
    selectedLocation: ""
  },
  loading: false,
  passsiveLoading: false
});

export default (state: State = blankState(), action: RootAction) => {
  switch (action.type) {
    case "dashboard/setSearchString":
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          searchString: action.searchString
        }
      };
    case "dashboard/setInactive":
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          showInactive: action.showInactive
        }
      };
    case "dashboard/setLocation":
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          selectedLocation: action.selectedLocation
        }
      };
    case "dashboard/getPatientList-started":
      return {
        ...state,
        passsiveLoading: true
      };
    case "dashboard/getPatientList-success":
      return {
        ...state,
        passsiveLoading: false,
        error: null,
        data: {
          ...state.data,
          patientList: action.patientList
        }
      };
    case "dashboard/getPatientList-failure":
      return {
        ...state,
        passsiveLoading: false
      };
    case "dashboard/getMorePatients-started":
      return {
        ...state,
        passsiveLoading: true
      };
    case "dashboard/getMorePatients-success":
      return {
        ...state,
        passsiveLoading: false,
        error: null,
        data: {
          ...state.data,
          patientList: {
            ...state.data.patientList,
            next: action.patientList.next,
            previous: action.patientList.previous,
            results: state.data.patientList.results.concat(action.patientList.results)
          }
        }
      };
    case "dashboard/getMorePatients-failure":
      return {
        ...state,
        passsiveLoading: false
      };
    case "dashboard/removePatientFromList":
      return {
        ...state,
        data: {
          ...state.data,
          patientList: {
            ...state.data.patientList,
            results: state.data.patientList.results.filter(p => p.id != action.patient.id)
          }
        },
        passsiveLoading: false
      };
    case "dashboard/getLocations-started":
      return {
        ...state,
        passsiveLoading: true
      };
    case "dashboard/getLocations-success":
      return {
        ...state,
        passsiveLoading: false,
        error: null,
        data: {
          ...state.data,
          locations: action.locations
        }
      };
    case "dashboard/getLocations-failure":
      return {
        ...state,
        passsiveLoading: false
      };
  }
  return state;
};
